module.exports = __webpack_public_path__ + "static/media/riskmatris.0f7ddda4.png";